<template>
  <Modal
    @closeModal="closeModal"
    v-show="showModal"
    :isSaving="isLoading"
    title="Delete Confirmation"
    :okFunction="deleteApp"
    okButtonLabel="Delete"
  >
    <template v-slot:body>
      <div class="delete-description">{{ message }}</div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { apiDeleteFile } from '@/api/content';
  import { CONTENT_REQUEST } from '@/store/actions/content';

  export default {
    name: 'ContentDeleteModal',

    components: { Modal },

    props: {
      content: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        showModal: false,
        isLoading: false,
        message: 'Are you sure you want to delete this content?',
        forceHide: false,
      };
    },

    mounted() {
      this.showModal = true;
    },

    methods: {
      async deleteApp() {
        this.isLoading = true;

        try {
          await apiDeleteFile(this.content.item_id, this.forceHide);

          this.$toasted.global.general_success({ message: 'Content successfully deleted' });
          this.$store.dispatch(CONTENT_REQUEST);
          this.$emit('onDelete');
          this.closeModal(true);
        } catch (error) {
          this.forceHide = true;
          this.message = `${
            error.response?.data?.message || 'Failed to delete the content.'
          } \n Please press the delete again to hide the item from the page and content browser.`;
        }
        this.isLoading = false;
      },

      closeModal() {
        this.showModal = false;
        this.$emit('closeModal');
      },
    },
  };
</script>
